import { render, staticRenderFns } from "./ListTabelas.vue?vue&type=template&id=34afb175"
import script from "./ListTabelas.vue?vue&type=script&lang=js"
export * from "./ListTabelas.vue?vue&type=script&lang=js"
import style0 from "./ListTabelas.vue?vue&type=style&index=0&id=34afb175&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports